"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeInvalidTotals = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
var bucketHelper_1 = require("../../../utils/bucketHelper");
function isNativeTotalInvalid(total, hasRankingFilter, hasMeasureValueFilter) {
    return sdk_model_1.totalIsNative(total) && (hasRankingFilter || hasMeasureValueFilter);
}
function removeInvalidNativeTotals(totals, filters) {
    var hasRankingFilter = filters.some(bucketHelper_1.isRankingFilter);
    var hasMeasureValueFilter = filters.some(bucketHelper_1.isActiveMeasureValueFilter);
    return totals.filter(function (total) { return !isNativeTotalInvalid(total, hasRankingFilter, hasMeasureValueFilter); });
}
function removeInvalidTotals(totals, filters) {
    return removeInvalidNativeTotals(totals, filters);
}
exports.removeInvalidTotals = removeInvalidTotals;
//# sourceMappingURL=totalsHelpers.js.map